import _ 				from "lodash";

import { Service } 		from "./../../Libs/Service";

import { Server } 		from "./Server";
import { Metadata } 	from "./Metadata";
import { Layout } 		from "./Layout";

import { Settings }		from "./Settings";
import SetupSettings from "../settings/settings.json";

let Template = new Service({

	Name: "Template",

	Libraries: [],

	Events: {

		'Metadata Loaded': function() {

			this.autoSelectTemplate();

		}

	},

	Actions: {

		'WebsitesUpdated': function (websites) {
			Metadata.Websites = websites;
		},

		'CreativeDownloadLink': function(url) {

			window.open(url, "blank");

		}

	},

	init() {

		//Текущий шаблон
		this.SelectedTemplate = null;

	},

	selectTemplate(template_id) {

		if (Metadata.Templates[template_id]) {

			this.SelectedTemplate = Metadata.Templates[template_id];

			Layout.setTemplate(template_id);

			Broadcast.call("Selected Template Changed", [template_id]);

			window.localStorage.setItem('selected-template-id', template_id);

			//Broadcast.call("Settings Selected", [Settings.SelectedSettings], {delay: 10});

		}

	},

	autoSelectTemplate() {

		//Отменяем сброс активного шаблона при переподключении к серверу (после потери связи с сервером чтобы не сбрасывался текущий экран интерфейса)
		if (this.SelectedTemplate && Metadata.Templates[this.SelectedTemplate.id]) return;

		if (window.localStorage.getItem('selected-template-id')) {

			let template_id = parseInt(window.localStorage.getItem('selected-template-id'));

			if (Metadata.Templates[template_id]) return this.selectTemplate(template_id);

		}

		this.selectTemplate(_.values(Metadata.Templates)[0].id);

	},

	downloadWebsitesCode() {

		let template = this.SelectedTemplate.id;

		let fileName = 'websites.json';
		let fileFolder = 'websites';
		if (template === 5) fileFolder = 'websites-mobile';
		//else if (template === 8) fileFolder = 'websites-interscroller'

		let url = `${location.protocol}//${SetupSettings["domain"]}:${location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"]}/${fileFolder}/${fileName}`;

		let xhr = new XMLHttpRequest();
		xhr.open("GET", url, true);
		xhr.responseType = "blob";
		xhr.withCredentials = true;
		xhr.onload = function(){
			let urlCreator = window.URL || window.webkitURL;
			let websitesUrl = urlCreator.createObjectURL(this.response);
			let tag = document.createElement('a');
			tag.href = websitesUrl;
			tag.download = fileFolder + '.json';
			document.body.appendChild(tag);
			tag.click();
			document.body.removeChild(tag);
		};
		xhr.send();
	},

	downloadExtraStyles() {

		let template = this.SelectedTemplate.id;

		let folder = template === 5 ? 'websites-mobile' : 'websites';

		let url = `${location.protocol}//${SetupSettings["domain"]}:${location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"]}/${folder}/extra-styles.css`;

		let xhr = new XMLHttpRequest();
		xhr.open("GET", url, true);
		xhr.responseType = "blob";
		xhr.withCredentials = true;
		xhr.onload = function(){
			let urlCreator = window.URL || window.webkitURL;
			let stylesUrl = urlCreator.createObjectURL(this.response);
			let tag = document.createElement('a');
			tag.href = stylesUrl;
			tag.download = template === 5 ? 'extra-styles-mobile.css' : 'extra-styles.css';
			document.body.appendChild(tag);
			tag.click();
			document.body.removeChild(tag);
		};
		xhr.send();
	},
	uploadWebsitesCode(file) {

		let formData = new FormData();

		formData.append("file", file);
		formData.append("template", this.SelectedTemplate.id);

		let url = 'http://' + SetupSettings["domain"] + ':' + SetupSettings["port"] + '/websites/get';
		if (location.protocol === 'https:') url = 'https://' + SetupSettings["domain"] + ':' + SetupSettings["portSSL"] + '/websites/get';

		let xhr = new XMLHttpRequest();

		xhr.withCredentials = true;

		xhr.open("POST", url);

		xhr.send(formData);

	},
	uploadExtraStyles(file) {

		let formData = new FormData();

		formData.append("file", file);
		formData.append("template", this.SelectedTemplate.id);


		let url = 'http://' + SetupSettings["domain"] + ':' + SetupSettings["port"] + '/styles/get';
		if (location.protocol === 'https:') url = 'https://' + SetupSettings["domain"] + ':' + SetupSettings["portSSL"] + '/styles/get';

		let xhr = new XMLHttpRequest();

		xhr.withCredentials = true;

		xhr.open("POST", url);

		xhr.send(formData);

	},

});

//Делаем глобальную ссылку для дебага - чтобы в консоли был виден этот объект сразу
window.Template = Template;

export { Template }

